import React from "react";
import { IconProps } from "../icon";

export const Upload_02Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 3H3m15 10l-6-6m0 0l-6 6m6-6v14"
    />
  </svg>
);
